/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2024-10-18 13:59:20
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-11 19:32:21
 */
import { unwrapResult } from '@reduxjs/toolkit'
import { Col, notification } from 'antd'
import moment from 'moment'
import React, {
  forwardRef,
  ReactElement,
  useContext,
  useEffect,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import { EditableList } from '../../../../compnents/list/EditableList'
// import styles from './AnnualCapitalFund.module.css'
import { Column } from './column'
import { Query } from './Query'
import { ThemeContext } from '../../../../theme/ThemeContext'
import {
  getTraceCodeFlowExportAsync,
  getTraceCodeFlowList,
} from './TraceCodeFlowSlice'
import { DateTimeFormatSimpleOnlyOne } from '../../../../models/datetime'

interface FeeLimitProps {
  selectedTab?: any
}

const TraceCodeFlow = ({ selectedTab }: FeeLimitProps): ReactElement => {
  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const [params, setParams] = useState<any>({
    current: 1,
    size: 10,
  })

  const [page, setPage] = useState<any>({ items: [], total: 0 })

  const [pageLoading, setPageLoading] = useState(false)

  const [exportLoading, setExportLoading] = useState(false)

  const [scrollHeight, setScrollHeight] = useState<any>()

  useEffect(() => {
    if (selectedTab == '6') {
      setPageLoading(true)
      getPage()
    }
  }, [selectedTab, params])

  const getPage = () => {
    dispatch(
      getTraceCodeFlowList({
        ...params,
        startTime: params?.startTime ?  params?.startTime : moment()?.startOf('day')?.format(DateTimeFormatSimpleOnlyOne),
        endTime: params?.endTime ? params?.endTime : moment()?.endOf('day')?.format(DateTimeFormatSimpleOnlyOne)
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        onResize() // 初始化设置高度
        window.addEventListener('resize', onResize)
        setPage({
          items: res.records,
          total: res.total,
        })

        setPageLoading(false)
      })
      .catch(() => {
        setPageLoading(false)
      })
  }

  const onResize = () => {
    const table = document.getElementById('tableHeight')
    if (table) {
      const height = table.offsetHeight - 60 - 80 - 20 - 20
      setScrollHeight(height)
    } else {
      return '100%'
    }
  }

  const outCluedExport = () => {
    setExportLoading(true)
    const data = {
      ...params,
      startTime: params?.startTime
        ? params?.startTime
        : moment()?.startOf('day')?.format(DateTimeFormatSimpleOnlyOne),
        endTime: params?.endTime
        ? params?.endTime
        : moment()?.endOf('day')?.format(DateTimeFormatSimpleOnlyOne),
    }
    dispatch(getTraceCodeFlowExportAsync(data))
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '追溯码流水.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        return
      })
      .finally(() => setExportLoading(false))
  }
  return (
    <Col
      style={{
        height: 'calc(100% - 10px)',
        borderRadius: theme.br,
        backgroundColor: theme.pn,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Query
        exportLoading={exportLoading}
        loading={pageLoading}
        onValueChange={(v: any) => {
          const paramData = {
            ...params,
            ...v,
          }
          setParams({
            ...paramData,
          })
        }}
        export={() => {
          outCluedExport()
        }}
      />
      <div
        id='tableHeight'
        style={{
          width: '100%',
          height: '100%',
        }}
      >
        <EditableList
          style={{
            width: '100%',
            height: '89%',
            overflow: 'hidden',
          }}
          scroll={{
            x: '33rem',
            y: page?.items?.length > 0 ? Number(scrollHeight) : undefined,
          }}
          rowKey={(v, i) => `${i}`}
          loading={pageLoading}
          page={{
            current: params?.current,
            size: params?.size,
            total: page?.total,
            items: page?.items,
          }}
          columns={Column(params?.size * (params?.current - 1))}
          onChangePage={(current, size) => {
            setParams({
              ...params,
              current,
              size,
            })
          }}
        />
      </div>
    </Col>
  )
}

export const TraceCodeFlows = forwardRef(TraceCodeFlow)
